import { Grid, IconButton } from "@material-ui/core";
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { setShowMenu } from "actions/user";
import { logOut } from "apis/index";
import {
  defaultFont,
  drawerWidth,
  primaryBoxShadow,
  transition,
  whiteColor,
} from "assets/jss/material-dashboard-react.js";
import classNames from "classnames";
import { get } from "lodash";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useHistory, useLocation, matchPath } from "react-router-dom";
import {
  getGalleryName,
  getPhotosByGallery,
  setDrawWidth,
} from "../../actions/gallery";
import LogoImg from "../../assets/images/logo/black_logo.png";
import { setEditingGallery } from "../../actions/gallery";
import {
  getLoggedInUserDisplayName,
  loggedInUser,
} from "../../v2_actions/auth";
const minDrawerWidth = 260;
const maxDrawerWidth = 1000;

const useStyles = makeStyles((theme) => ({
  separator: {
    width: "100%",
    marginTop: "5px",
    height: "1px",
    backgroundColor: "#7A7A7A",
  },
  list: {
    marginTop: "5px",
    paddingLeft: "0",
    paddingTop: "0",
    paddingBottom: "0",
    marginBottom: "0",
    listStyle: "none",
    position: "unset",
  },
  item: {
    position: "relative",
    display: "block",
    textDecoration: "none",
    "&:hover,&:focus,&:visited,&": {
      color: whiteColor,
    },
  },
  itemLink: {
    width: "auto",
    transition: "all 300ms linear",
    borderRadius: "3px",
    position: "relative",
    display: "block",
    backgroundColor: "transparent",
    fontWeight: 900,
    ...defaultFont,
  },
  itemIcon: {
    width: "25px",
    height: "20px",
    fontSize: "15px",
    lineHeight: "20px",
    float: "left",
    marginRight: "10px",
    marginLeft: "15px",
    textAlign: "center",
    verticalAlign: "middle",
    color: "#565656",
  },
  itemText: {
    ...defaultFont,
    margin: "0",
    fontFamily: "Raleway, sans-serif",
    lineHeight: "20px",
    fontSize: "12px",
    color: "#505050",
  },
  nestedItemText: {
    fontWeight: "600",
    color: "#565656",
    position: "relative",
    top: "0.5px",
  },
  drawerPaper: {
    position: "fixed",
    top: "0",
    height: "100%",
    bottom: "0",
    overflow: "hidden",
    flexShrink: 0,
    zIndex: 9999,
    background: "#ededed",
    overflowScrolling: "auto",
    color: "#7A7A7A",
    borderTop: "none",
    width: drawerWidth,
    borderRight: "none",
    [theme.breakpoints.up("md")]: {
      width: `calc(${drawerWidth}px - 30px)`,
      position: "fixed",
      height: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      width: `calc(${drawerWidth}px - 30px)`,
      position: "",
      display: "block",
      top: "0",
      height: "100vh",
      right: "0",
      left: "auto",
      zIndex: "1032",
      visibility: "visible",
      overflowY: "visible",
      borderTop: "none",
      textAlign: "left",
      paddingRight: "0px",
      paddingLeft: "0",
      transform: `translate3d(${drawerWidth}px, 0, 0)`,
      ...transition,
    },
  },
  subMenu: {
    display: "flex",
    paddingLeft: 15,
    paddingBottom: 3,
    fontSize: 18,
    fontWeight: "500",
    cursor: "pointer",
    "&:hover,&:focus": {
      backgroundColor: "#1da1f2",
      ...primaryBoxShadow,
    },
  },
  sidebarWrapper: {
    position: "relative",
    height: "auto",
    overflow: "auto",
    zIndex: "4",
    overflowScrolling: "touch",
    "& a:hover": {
      background: "#929292",
    },
  },
  dragger: {
    width: "0",
    cursor: "ew-resize",
    padding: "6px 0 0",
    borderTop: "1px solid #ddd",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    zIndex: 100,
  },
  container: {
    zIndex: 99,
    alignItems: "center",
    justifyContent: "space-between",
  },
  logo_row: {
    display: "flex",
    alignItems: "center",
    width: "60%",
    justifyContent: "space-between",
  },
  logo: {
    width: "260px",
  },

  title: {
    display: "flex",
    marginTop: "0px",
    marginBottom: "0px",
  },
  logo_img: {
    width: "170px",
    height: "34px",
    marginLeft: "-10px",
    marginTop: "14px",
  },
  activeLink: {
    backgroundColor: "rgb(3, 48, 118)",

    "& .MuiListItemText-root,& .MuiSvgIcon-root": {
      color: "#fff !important",
    },
  },
  wrapper: {
    marginRight: "10px",
  },
  mainItem: {
    fontWeight: 800,
  },
  opaque: {
    opacity: "0.30 !important",
    pointerEvents: "none",
  },
}));

export const ContextMenuSidebar = ({ color, routes }) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const displayName = getLoggedInUserDisplayName();
  const is_staff = get(loggedInUser(), "is_staff");
  const drawerWidth = useSelector((state) => state.gallery.drawWidth);
  const showMenu = useSelector((state) => state.user.showMenu);
  const location = useLocation();
  const isLoading = useSelector((state) => state.ui.isLoading);

  function activeRoute(routeName) {
    return window.location.href.indexOf(routeName) > -1 ? true : false;
  }
  const onUploadNewGallery = () => {
    dispatch(setEditingGallery({}));
  };

  function signOut() {
    dispatch(getPhotosByGallery([]));
    dispatch(getGalleryName(null, null));
    logOut();
    history.push(`/photographer/login`);
  }

  const handleMouseDown = (e) => {
    document.addEventListener("mouseup", handleMouseUp, true);
    document.addEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseUp = () => {
    document.removeEventListener("mouseup", handleMouseUp, true);
    document.removeEventListener("mousemove", handleMouseMove, true);
  };

  const handleMouseMove = useCallback((e) => {
    const newWidth = e.clientX - document.body.offsetLeft;
    if (newWidth > minDrawerWidth && newWidth < maxDrawerWidth) {
      dispatch(setDrawWidth(newWidth));
    }
    // eslint-disable-next-line
  }, []);

  let links = (
    <List className={classes.list}>
      {routes.map((prop, ind) => {
        let activeLinkItem = matchPath(location.pathname, {
          path: prop.path,
          exact: true,
          strict: false,
        })
          ? classes.activeLink
          : "";

        let listItemClasses = classNames({
          [" " + classes[color]]: activeRoute(prop.path),
        });

        const renderNavLinkContent = () => {
          return (
            <>
              <ListItem
                button
                className={`${classes.itemLink} ${listItemClasses}`}
              >
                {prop.icon !== null && (
                  <prop.icon className={classNames(classes.itemIcon)} />
                )}
                <ListItemText
                  primary={prop.name}
                  className={classNames(
                    classes.itemText,
                    prop.icon !== null ? classes.nestedItemText : "",
                    prop.icon === null ? classes.mainItem : "",
                  )}
                  disableTypography={true}
                />
              </ListItem>
              {prop.underline && <div className={classes.separator} />}
            </>
          );
        };
        return (
          <div key={`${ind}-links-child-div`}>
            {prop.showable && !prop.openLinkInNewBrowserTab && (
              <NavLink
                to={prop.path}
                className={`${activeLinkItem}  ${classes.item}`}
                activeClassName="active"
                key={`${ind}-navlink`}
                onClick={() => {
                  dispatch(setShowMenu(!showMenu));
                  prop?.isCreate && onUploadNewGallery();
                }}
              >
                {renderNavLinkContent()}
              </NavLink>
            )}
            {prop.showable && prop.openLinkInNewBrowserTab && (
              <a
                href={prop.path}
                target="_blank"
                className={`${activeLinkItem}  ${classes.item}`}
                activeClassName="active"
                key={`${ind}-navlink`}
                onClick={() => {
                  dispatch(setShowMenu(!showMenu));
                  prop?.isCreate && onUploadNewGallery();
                }} rel="noreferrer"
              >
                {renderNavLinkContent()}
              </a>
            )}
          </div>
        );
      })}
    </List>
  );

  return (
    <div className={`${classes.wrapper} ${isLoading && classes.opaque}`}>
      <Hidden mdUp>
        <Drawer
          variant="temporary"
          anchor={"right"}
          open={showMenu}
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          {is_staff === "true" && (
            <div
              className={classes.subMenu}
              style={{ flexDirection: "column" }}
            >
              <div
                style={{ display: "flex" }}
                onClick={() => history.push(`/photographer/editdetails`)}
              >
                <AccountCircleIcon />
                <span>{displayName}</span>
              </div>
              <div style={{ paddingLeft: 38 }} onClick={() => signOut()}>
                <span>Sign Out</span>
              </div>
            </div>
          )}

          <div className={classes.sidebarWrapper} key="navlink1">
            {links}
          </div>
        </Drawer>
      </Hidden>
      <Hidden smDown>
        <div
          classes={{
            paper: classNames(classes.drawerPaper),
          }}
        >
          <div
            onMouseDown={(e) => handleMouseDown(e)}
            className={classes.dragger}
          />
          {displayName && (
            <div
              style={{ flexDirection: "column", height: 65, paddingLeft: 20 }}
            >
              <Grid item xs={1}>
                <IconButton onClick={() => dispatch(setShowMenu(true))}>
                  <img src={LogoImg} alt="/" className={classes.logo_img} />
                </IconButton>
              </Grid>
            </div>
          )}
          <div className={classes.sidebarWrapper} key="navlink1">
            {links}
          </div>
        </div>
      </Hidden>
    </div>
  );
};
